import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';

const FooterWrapper = styled.footer`
  background-color: #f6ece6;
  padding: 3rem 2rem;
`;

const FooterInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterBrand = styled(Link)`
  font-family: 'Epilogue', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #a0412d;
  text-decoration: none;
`;

const FooterCopy = styled.p`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.875rem;
  color: #665d58;
`;

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const FooterLink = styled.a`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.875rem;
  color: #665d58;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #a0412d;
  }
`;

const SocialLink = styled.a`
  font-size: 1.125rem;
  color: #665d58;
  transition: color 0.2s ease;

  &:hover {
    color: #a0412d;
  }
`;

const Footer = () => (
  <FooterWrapper>
    <FooterInner>
      <FooterBrand to="/">Sari Angus</FooterBrand>
      <FooterCopy>© {new Date().getFullYear()} Sari Angus. All rights reserved.</FooterCopy>
      <FooterLinks>
        <FooterLink href="mailto:liz@lbfactors.nz">liz@lbfactors.nz</FooterLink>
        <SocialLink
          href="https://www.instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </SocialLink>
      </FooterLinks>
    </FooterInner>
  </FooterWrapper>
);

export default Footer;
